import React from 'react';
import { Shield, Lock, Key } from 'lucide-react';

interface Tab {
  id: string;
  name: string;
  icon: React.ElementType;
}

interface Props {
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

const SecurityTabs: React.FC<Props> = ({ activeTab, onTabChange }) => {
  const tabs: Tab[] = [
    { id: 'dnssec', name: 'DNSSEC', icon: Shield },
    { id: 'security', name: 'Security', icon: Lock },
    { id: 'keys', name: 'API Keys', icon: Key },
  ];

  return (
    <nav className="space-y-1 p-4">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
              activeTab === tab.id
                ? 'bg-blue-50 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300 border-blue-200 dark:border-blue-800'
                : 'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800'
            }`}
          >
            <Icon className="w-5 h-5 mr-3" />
            {tab.name}
          </button>
        );
      })}
    </nav>
  );
};

export default SecurityTabs;